import ProgramApis from '@/app/program/apis'
import ProgramListing from '@/app/program/listing'
import generateStaticProps from '@/utils/generate-static-props'

export default ProgramListing

export const getStaticProps = async () => {
  return generateStaticProps(() => ProgramApis.getAll())
}
